
// Predefine global variables
var
	equalHeightGroup,
	equalHeight = {},
	equalWidthGroup,
	equalWidth = {},
	slider_length,
	slider_current = 0,
	$ = jQuery;

$(function(){

 	// get viewport width
 	var viewportWidth = Math.max( document.documentElement.clientWidth, window.innerWidth || 0 );

	// Format images with dotted circle overlay
	if( $('.js__striped-circle').length ) {

		$('.js__striped-circle').each(function() {
			var image_source = $(this).attr('data-src');
			// var striped_circle = $(this).css('background-image');
			var background_size = $(this).css('background-size');
			var background_position = $(this).css('background-position');

			$(this).css('background-image', 'url("/assets/images/striped-circle.png"), url("' + image_source + '")');
			$(this).css('background-position', background_position + ', center center');
			$(this).css('background-size', background_size + ', cover');
		});

	}



	// Set the background color based on image
	if( $('.js__blog-background').length ) {
		$('.p-blog--images-container').imagesLoaded( function() {
			var colorThief = new ColorThief();
			$('.js__blog-background').each(function() {

				// Set background image based on data-src attribute
				var image_id = '#' + $(this).attr('data-src');
				var image_source = $(image_id).attr('src');

				// Override default background color based on background image
				// If this fails, use default background color
				try {
					var background_color = colorThief.getColor($(image_id)[0]).join();
				}
				catch(e) {
					var background_color = '46, 74, 94';
				}

				// Set background image and color
				$(this).css('background-color', 'rgb(' + background_color + ')');
				$(this).css('background-image', 'linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 49%, rgb(255, 255, 255) 49%, rgb(255, 255, 255) 50%, rgb(' + background_color + ') 50%, rgb(' + background_color + ')), url(' + image_source + ')');
			});
		});
	}




	// Toggle and autofocus the search form
	if( $('.js__togglesearch').length ) {
		$('.js__togglesearch').click(function() {
			$('html, body').animate({ scrollTop: 0 }, 0);
			setTimeout(function() {
				$('.p-navigation--search-form').toggleClass('p-navigation--search-form__hidden');
				if( !$('.p-navigation--search-form').hasClass('p-navigation--search-form__hidden') ) {
					$('.p-navigation--search-form input').focus();
				}
			}, 300);
			return false;
		})
	}



	// Create containers of equal height/width, based on the highest/widest
	window.onload = function(){
		if( $('.js__equalheight').length ) {

			$('.js__equalheight').each(function() {
				equalHeightGroup = $(this).attr('data-equalheightgroup');
				if(typeof equalHeight[equalHeightGroup] == 'undefined') {
					equalHeight[equalHeightGroup] = 0;
				}
				equalHeight[equalHeightGroup] = Math.max(equalHeight[equalHeightGroup], $(this).height());
			});

			$('.js__equalheight').each(function() {
				equalHeightGroup = $(this).attr('data-equalheightgroup');
				$(this).height(Math.round(equalHeight[equalHeightGroup])+'px');
			});

		}

		if( $('.js__equalwidth').length ) {

			$('.js__equalwidth').each(function() {
				equalWidthGroup = $(this).attr('data-equalwidthgroup');
				if(typeof equalWidth[equalWidthGroup] == 'undefined') {
					equalWidth[equalWidthGroup] = 0;
				}
				equalWidth[equalWidthGroup] = Math.max(equalWidth[equalWidthGroup], $(this).width());
			});

			$('.js__equalwidth').each(function() {
				equalWidthGroup = $(this).attr('data-equalwidthgroup');
				$(this).width(Math.round(equalWidth[equalWidthGroup])+'px');
			});

		}

	};



	// Initialize Gravity Forms outside Gravity Forms
	if( $('#gform_1').length ) {
		$(document).bind('gform_post_render', function(event, formId, currentPage) {
			if(formId == 1) {
				if(typeof Placeholders != 'undefined') {
					Placeholders.enable();
				}
			}
		});
		$(document).bind('gform_post_conditional_logic', function(event, formId, fields, isInit){});
		$(document).ready(function() {
			$(document).trigger('gform_post_render', [1, 1])
		});
	}



	// Background fader
	if ( viewportWidth > 767 )
	{
		if( $('.p-slider--background').length > 1 ) {
			slider_length = $('.p-slider--background').length;

			setInterval(function(){
				slider_current = (slider_current + 1) % slider_length;
				$('.p-slider--background').addClass('p-slider--background__hidden');
				$('.p-slider--background:eq(' + slider_current + ')').removeClass('p-slider--background__hidden');
				$('.p-slider--content').addClass('p-slider--content__hidden');
				$('.p-slider--content:eq(' + slider_current + ')').removeClass('p-slider--content__hidden');
				$('.p-slider--service-container').removeClass('p-slider--service-container__active');
				$('.p-slider--service-container:eq(' + slider_current + ')').addClass('p-slider--service-container__active');
			}, 6000);
		}
	}

	// Menu scroller
	if( $('.js__scroll-to-menu').length ) {
		$('html, body').animate({ scrollTop: $('.p-navigation__desktop').offset().top }, 500);
	}



	// Tabindex reset
	var tabindex = 0;
	setTimeout(function(){
		$('[tabindex]').each(function() {
			tabindex++;
			$(this).attr('tabindex', tabindex);
		});
	}, 1000);



	// Workshop modal preprocessor
	$('.js__subscribe-workshop').click(function(){

		$('.js__workshop-title').html( $('.p-workshop__title', $(this).closest('.p-workshop')).html() );
		$('.workshop__name input').val($(this).attr('data-workshop'));
		$('.workshop__name').hide();

		// Fill participants selectbox
		$('.workshop__participants select').html('');
		for(var i = 1; i <= $(this).attr('data-max'); i++) {
			$('<option>').val(i).html(i).appendTo($('.workshop__participants select'));
		}
	});

	// Handle modal
	$('#workshopModal').on('hidden.bs.modal', function(ev) {
		window.location.reload();
	});

	// Toggle workshop data
	$('.js__toggle-workshop').click(function(ev) {
		ev.preventDefault();
		var $parent = $(this).closest('.p-workshop__data-container')
		$('.p-workshop__excerpt', $parent).toggleClass('p-workshop__hidden');
		$('.p-workshop__content', $parent).toggleClass('p-workshop__hidden');
	});

	/**
	 * Owl Carousel.
	 */

	if ( viewportWidth <= 767 )
	{
		// owl base config
		var owlbaseconfig = {
			items: 1,
			dots: true,
			margin: 30,
			nav: false,
			autoHeight: true,
			autoplayTimeout: 5000,
			autoplaySpeed: 500,
			autoplayHoverPause: true,
		};
		// owl config 1
		var owlconfig1 = Object.assign( {}, owlbaseconfig );
		// owl config 2
		var owlconfig2 = Object.assign( {}, owlbaseconfig );
		owlconfig2.autoplay = true;
		owlconfig2.loop = true;
		// owl config 3
		var owlconfig3 = Object.assign( {}, owlbaseconfig );
		owlconfig2.loop = true;
		owlconfig3.startPosition = $( '.js-slider-3' ).attr( 'data-startposition' );
		// init
		$( '.js-slider' ).addClass( 'owl-carousel owl-theme' );
		// init 1
		$( '.js-slider-1' ).owlCarousel( owlconfig1 );
		// init 2
		$( '.js-slider-2' ).owlCarousel( owlconfig2 );
		// init 3
		$( '.js-slider-3' ).owlCarousel( owlconfig3 );
	}

});



// Google Maps
function pMaps() {

	if(document.getElementById('pMaps') === null) {
		return false;
	}

	var pMap = new google.maps.Map( document.getElementById('pMaps'), {
		center: { lat: 1 * pContact.LAT, lng: 1 * pContact.LON },
		zoom: 17,
	    scrollwheel: false,
	    navigationControl: true,
	    mapTypeControl: true,
	    scaleControl: false,
	    draggable: true
	});

	var pMarker = new google.maps.Marker({
		map: pMap,
		position: { lat: 1 * pContact.LAT, lng: 1 * pContact.LON },
	});
}
